export default "__VITE_ASSET__CZGEcxHO__"